<ng-container *ngIf="{ request: requestHeatpumpCurrentData$ | async } as resolver">
  <ng-container *ngIf="selectHeatpumpCurrentData$ | async as heatpumpData; else skeletonTemplate">
    <ng-container *ngIf="selectedHeatpumpCurrentConfig$ | async as currentConfig">
      <lib-block-title
        id="heatpump-flow-chart-title"
        [title]="labels.title">
      </lib-block-title>

      <div
        id="heatpump-flow-chart-container"
        class="fx-col fx-gap-4 fx-align-center one-column vertical fx-g-1">
        <!-- Ingresso (ritorno) -->
        <div class="fx-g-1 fx-col fx-center fx-gap-3 pos-rel">
          <div class="fx-col fx-align-center h-full">
            <div
              class="flow-line"
              aria-hidden="true">
            </div>
          </div>
          <div class="temperature-label bg-white opacity-80 ">{{ heatpumpData.RET_TEMP | celsiusTemperature }}</div>
        </div>

      <!-- Heatpump -->
        <div
          class="s-20 p-2 rounded fx-center"
          aria-hidden="true"
          [ngClass]="{
            'cooling-active': heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Cooling,
            'heating-active': heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Heating || heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.HotWater
          }">
          <img
            alt="heatpump"
            [src]="currentConfig.globStatus != AHglobStatusEnum.Shutdown && currentConfig.globStatus != AHglobStatusEnum.Standby ?
              'blocks-assets/images/productImages/other/flow-heat-pump-on.svg' :
              'blocks-assets/images/productImages/other/flow-heat-pump-off.svg'"/>
        </div>

        <!-- Uscita: OUT_TEMP sopra la linea e coda -->
        <div class="fx-col fx-align-center one-column vertical pos-rel">
          <div class="fx-col fx-align-center h-full">
            <div
              class="flow-line"
              [ngClass]="{
                'is-cooling': heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Cooling,
                'is-heating': heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Heating || heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.HotWater
              }">
            </div>
          </div>
          <div class="temperature-label bg-white opacity-80">{{ heatpumpData.OUT_TEMP | celsiusTemperature}}</div>
        </div>

        <!-- Endpoint a destra: sempre uno, deciso solo dalla modalità corrente -->
        <div class="fx-row fx-gap-2">
          <ng-container [ngSwitch]="heatpumpData.CURR_OP_MODE">
            <!-- Endpoint DHW quando in HotWater -->
            <div
              *ngSwitchCase="AHcurrOpModeEnum.HotWater"
              class="fx-row fx-gap-3">
              <div class="fx-col fx-center s-20 p-2 rounded heating-active pos-rel">
                <ion-icon
                  class="s-18"
                  src="blocks-assets/images/productImages/other/dhw.svg"
                  alt="DHW">
                </ion-icon>
                <span class="body-2 mt-0 text-grey-400 text-style-italic text-bold">
                  {{ currentConfig.DHWSetTemp | celsiusTemperature }}
                </span>
                <!-- Temperatura attuale boiler sotto (DHW_TEMP) -->
                <div class="pos-abs text-300 bg-red-100 text-red-400 radius-12">
                  {{ heatpumpData.DHW_TEMP | celsiusTemperature }}
                </div>
              </div>
            </div>
            <!-- Endpoint CLIMA Cooling -->
            <div
              *ngSwitchCase="AHcurrOpModeEnum.Cooling"
              class="fx-row fx-gap-3">
              <div class="fx-col fx-center s-20 p-2 rounded cooling-active">
                <!-- Set temp sopra (Clima Cooling) -->
                <ion-icon
                  class="s-18"
                  src="blocks-assets/images/productImages/other/cooling.svg">
                </ion-icon>
                <span class="body-2 mt-0 text-grey-400 text-style-italic text-bold">
                  {{ currentConfig.climSetTempCoolingA | celsiusTemperature }}
                </span>
              </div>
            </div>
            <!-- Endpoint CLIMA Heating per tutte le altre modalità di spazio -->
            <div
              *ngSwitchDefault
              class="fx-row fx-gap-3">
              <div class="fx-col fx-center s-20 p-2 rounded heating-active">
                <ion-icon
                  class="s-18"
                  src="blocks-assets/images/productImages/other/heating.svg"
                  alt="Clima Heating">
                </ion-icon>
                <span class="body-2 mt-0 text-grey-400 text-style-italic text-bold">
                  {{ currentConfig.climSetTempHeatingA | celsiusTemperature }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div
        id="heatpump-telemetry-timestamp"
        class="text-style-italic capitalize-first text-right last-updated">
        <div *ngIf="heatpumpData.TS">
          {{ (heatpumpData.TS * 1000) | timeAgo }}
          <div *ngIf="systemTimezone$ | async as offset">
            {{ 'UTC' | uppercase }} {{ offset > 0 ? '+' : '-' }}{{ offset }}
          </div>
        </div>
      </div>
      <div
        id="heatpump-flow-chart-mode"
        class="fx-row w-full fx-align-center fx-justify-between p-3 fx-gap-3 p-1 block-bg-contrast ">
        <div class="fx-row fx-gap-3 fx-align-center">
          <mat-icon class="s-6 text-grey-400">compare_arrows</mat-icon>
          <p class="tw-text-sm tw-font-medium text-grey-300">{{labels.modeTitle}}</p>
        </div>
        <p class="tw-text-base tw-font-normal text-grey-400">
          {{ heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Cooling ? labels.cooling :
            (heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.Heating ? labels.heating :
            (heatpumpData.CURR_OP_MODE === AHcurrOpModeEnum.HotWater ? labels.hotWater : '')) }}
        </p>
      </div>

      <div
        id="heatpump-env-temp"
        class="fx-row w-full fx-align-center fx-justify-between p-3 fx-gap-3 p-1 block-bg-contrast ">
        <div class="fx-row fx-gap-3 fx-align-center">
          <mat-icon class="s-6 text-grey-400">thermostat</mat-icon>
          <p class="tw-text-sm tw-font-medium text-grey-300">{{labels.envTemp}}</p>
        </div>
        <p class="tw-text-base tw-font-normal text-grey-400">{{ heatpumpData.ENV_TEMP | celsiusTemperature }}</p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #skeletonTemplate>
  <ion-skeleton-text
    id="heatpump-flow-chart-title"
    class="w-42 h-16"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="heatpump-flow-chart-container"
    class="w-full tw-h-96"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="heatpump-telemetry-timestamp"
    class="w-32 h-6 mt-2 ml-auto"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="heatpump-flow-chart-mode"
    class="w-full h-12 mt-2"
    [animated]="true">
  </ion-skeleton-text>
  <ion-skeleton-text
    id="heatpump-env-temp"
    class="w-full h-12 mt-2"
    [animated]="true">
  </ion-skeleton-text>
</ng-template>